import axios from 'axios'

const API_URLS = process.env.REACT_APP_API_URLS

export interface Filter {
  field: string | null
  type: string | null
  params?: string | null
}

export const getListTransactions = async (search: any, page: any, filter: Filter) => {
  let url = `${API_URLS}/transactions?populate=*&`
  if (page) url += `pagination[pageSize]=5&pagination[page]=${page}&`
  if (search) url += `_q=${search}&`
  if (filter?.field && filter?.type) url += `filters${filter.field}=${filter.type}`
  if (filter?.params) url += filter.params
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getListTransactionRecords = async (search: any, page: any, filter: any) => {
  let url = `${API_URLS}/transaction-records?`
  if (page) url += `pagination[pageSize]=5&pagination[page]=${page}&`
  if (search) url += `_q=${search}&`
  if (filter) url += `filters[status][$eq]=${filter}`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getListTransactionsByMemberId = async (id: any) => {
  let url = `${API_URLS}/transactions?populate=*&filters[Member][id][$eq]=${id}`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getTransactionRecordById = async (id: any) => {
  let url = `${API_URLS}/transaction-records/${id}?populate=*`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const exportTransactions = async () => {
  let url = `${API_URLS}/transactions?populate=*&`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const postTransactions = async (datas: any) => {
  try {
    const response = await axios.post(`${API_URLS}/transactions/add`, datas)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const reverseTransactionsById = async (data: any) => {
  try {
    const response = await axios.post(`${API_URLS}/transactions/reverse?memberId=${data.memberId}&transactionId=${data.id}`)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getDetailTransactions = async (id: any) => {
  let url = `${API_URLS}/transactions/${id}?populate=*`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const putTransactions = async (data: any) => {
  let url = `${API_URLS}/transactions/update/${data.id}`
  try {
    const response = await axios.put(url,data.form)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const putTransactionRecords = async (data: any) => {
  let url = `${API_URLS}/transaction-records/${data.id}`
  try {
    const response = await axios.put(url, {data: data.data})
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const importReceiptTransactions = async (data: any) => {
  let url = `${API_URLS}/transactions/receipt`
  try {
    const response = await axios.post(url, data)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getDetailTransactionsAll = async (id: any) => {
  let url = `${API_URLS}/transactions?populate[transaction_details][populate]=product&populate=Member&filters[id][$eq]=${id}`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}